function initMatrixRain(canvasId, options = {}) {
  const canvas = document.getElementById(canvasId);
  const ctx = canvas.getContext('2d');
  const container = canvas.parentElement;
  const fontSize = options.fontSize || 30;
  const tailLength = options.tailLength || 5;
  const stepInterval = options.stepInterval || 10;
  const chars = options.chars || '1111000ｶｶｶｶﾏﾏﾏﾎﾎﾎﾓﾓ';

  let columns, drops, tickCounters, w, h, dpr;

  function resize() {
    dpr = window.devicePixelRatio || 1;
    w = container.clientWidth;
    h = container.clientHeight;

    canvas.width = Math.floor(w * dpr);
    canvas.height = Math.floor(h * dpr);
    canvas.style.width = w + 'px';
    canvas.style.height = h + 'px';

    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.scale(dpr, dpr);

    columns = Math.floor(w / fontSize);
    const rowsTotal = Math.ceil(h / fontSize) + tailLength;
    drops = new Array(columns)
      .fill(0)
      .map(() => -Math.floor(Math.random() * rowsTotal));
    tickCounters = new Array(columns)
      .fill(0)
      .map(() => Math.floor(Math.random() * stepInterval));

    ctx.fillStyle = '#000';
    ctx.fillRect(0, 0, w, h);
  }

  resize();
  window.addEventListener('resize', resize);

  function draw() {
    ctx.fillStyle = 'rgba(0,0,0,0.25)';
    ctx.fillRect(0, 0, w, h);
    ctx.font = fontSize + 'px monospace';
    ctx.textAlign = 'center';

    const rowsTotal = Math.ceil(h / fontSize) + tailLength;

    for (let i = 0; i < columns; i++) {
      tickCounters[i]++;
      if (tickCounters[i] >= stepInterval) {
        tickCounters[i] = 0;
        drops[i]++;
        if (drops[i] - tailLength > rowsTotal)
          drops[i] = -Math.floor(Math.random() * 10);
      }

      const x = i * fontSize + fontSize / 2;
      const headRow = drops[i];

      for (let t = 0; t < tailLength; t++) {
        const row = headRow - t;
        if (row < 0) continue;
        const ty = row * fontSize + fontSize;
        if (ty > h + fontSize) continue;

        const fade = Math.max(0, 1 - t / tailLength);
        const ch = chars[Math.floor(Math.random() * chars.length)];

        if (t === 0) {
          ctx.shadowColor = 'rgba(255,255,255,0.2)';
          ctx.shadowBlur = 10;
          ctx.fillStyle = 'rgba(255,255,255,0.2)';
        } else {
          ctx.shadowBlur = 0;
          ctx.fillStyle = `rgba(31,222,0,${(fade * 0.4).toFixed(2)})`;
        }
        ctx.fillText(ch, x, ty);
      }
      ctx.shadowBlur = 0;
    }
    requestAnimationFrame(draw);
  }
  draw();
}

initMatrixRain('matrix-rain', { stepInterval: 10 });
